import { action } from 'mobx';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import FeedbackReportForm from 'stores/Forms/Reports/Feedback/FeedbackReportForm';
import FeedbackReportStore from 'stores/Report/Feedback/FeedbackReportStore';
import { printPage } from 'helpers/print';

import Button from 'components/Button/Button';
import Datepicker from 'components/Form/Fields/Datepicker/Datepicker';
import { bindFormControl } from 'components/Form/FormControl/FormControl';
import Icon from 'components/Icon/Icon';

import style from './FeedbackReportTab.module.scss';

interface Props {
  form: FeedbackReportForm;
  store: FeedbackReportStore;
}

@observer
class FeedbackForm extends Component<Props> {
  private _formControl = bindFormControl(this.props.form);

  @action.bound
  async getReport() {
    const form = this.props.form;

    if (form.isFormValid) {
      await this.props.store.getReport(form.requestParams);
    }
  }

  render() {
    const { form } = this.props;
    const FormControl = this._formControl;

    return (
      <div className={style.formWrapper}>
        <form className={style.form}>
          <div className={style.form__field}>
            <label className={style.form__label}>
              <FormattedMessage id="title.period" />
            </label>

            <FormControl
              name="period"
              render={props => (
                <Datepicker
                  {...props}
                  styles={{
                    calendar: style.datepicker,
                    button: style.datepicker__btn,
                  }}
                  value={form.period}
                  selectRange
                />
              )}
            />
          </div>

          <Button
            className={style.button}
            onClick={this.getReport}
            disabled={!form.isFormValid}
          >
            <FormattedMessage id="button.generate.report" />
          </Button>
        </form>
        <Button
          styleType="text"
          onClick={() => printPage()}
          className={style.print__btn}
        >
          <Icon type="print" />
        </Button>
      </div>
    );
  }
}

export default FeedbackForm;
